module.exports = __webpack_public_path__ + "static/media/all_of_me_pluspunkt.8866a06f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snippets/all_of_me_pluspunkt.mp3
// module id = 183
// module chunks = 0